import { pgTable, varchar, decimal, date, timestamp, unique, boolean, uuid } from "drizzle-orm/pg-core";
import { sql } from "drizzle-orm";
import { organizations } from "./organizations";
import { users } from "./users";

export const timesheets = pgTable("timesheets", {
  id: varchar("id").primaryKey().default(sql`gen_random_uuid()`),
  userId: varchar("user_id").notNull().references(() => users.id, { onDelete: "cascade" }),
  weekStartDate: date("week_start_date").notNull(), // Sunday of the week (YYYY-MM-DD)
  sunHours: decimal("sun_hours", { precision: 5, scale: 2 }),
  monHours: decimal("mon_hours", { precision: 5, scale: 2 }),
  tueHours: decimal("tue_hours", { precision: 5, scale: 2 }),
  wedHours: decimal("wed_hours", { precision: 5, scale: 2 }),
  thuHours: decimal("thu_hours", { precision: 5, scale: 2 }),
  friHours: decimal("fri_hours", { precision: 5, scale: 2 }),
  satHours: decimal("sat_hours", { precision: 5, scale: 2 }),
  status: varchar("status", { length: 20 }).notNull().default("draft"), // 'draft' | 'submitted'
  submittedAt: timestamp("submitted_at"),
  isPaid: boolean("is_paid").notNull().default(false),
  paidAt: timestamp("paid_at"),
  paidBy: varchar("paid_by").references(() => users.id, { onDelete: "set null" }),

  orgId: uuid("org_id").references(() => organizations.id, { onDelete: "cascade" }),

  createdAt: timestamp("created_at").defaultNow(),
  updatedAt: timestamp("updated_at").defaultNow(),
}, (table) => ({
  userWeekUnique: unique().on(table.userId, table.weekStartDate),
}));
